import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { ModalServiceService } from '@shared/services/modal-service/modal-service.service';
import { DownloadService } from '@shared/services/download/download.service';
import { ExportServiceService } from '@shared/services/export-service/export-service.service';
import { DateConverterService } from '@shared/services/date-converter/date-converter.service';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { UserPermisionsFactory } from '@shared/factories/user-permisions/user-permisions.factory';
import { GlobalCfgFactory } from '@shared/factories/global-cfg/global-cfg.factory';
import { ConvertDatePipe } from '../../filters/convert-date/convert-date.pipe';
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';
import { AfOrderByPipe } from '@shared/filters/af-order-by/af-order-by.pipe';
import { FormsModule } from '@angular/forms';
import { AfTranslateDirective } from '../../modules/translate/directive/af-translate.directive';
import { NgShowDirective } from '../../directives/ng-show/ng-show.directive';
import { TooltipModule } from 'primeng/tooltip';
import { NgClass } from '@angular/common';
import { PdfHeaderComponent } from '@shared/components/pdf-header/pdf-header.component';
import { CustomLandingFactory } from '@shared/factories/custom-landing/custom-landing.factory';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { ApiServiceService } from '@shared/services/api-service/api-service.service';
import { ContextFactory } from '@shared/factories/context/context.factory';
import { AfLimitToPipe } from '@shared/filters/af-limit-to/af-limit-to.pipe';

@Component({
    selector: 'box-communication-channel',
    templateUrl: './box-communication-channel.component.html',
    standalone: true,
    imports: [NgClass, TooltipModule, NgShowDirective, AfTranslateDirective, FormsModule, AfOrderByPipe, AfTranslatePipe, ConvertDatePipe, PdfHeaderComponent, AfLimitToPipe]
})
export class BoxCommunicationChannelComponent implements OnInit, OnDestroy {
  skin: any = this.globalCfg.skin;
  isLanding: Boolean = this.customLanding.isLanding();
  userPermissions: any = this.permissions.getPermissions();
  subscribers: any = {};
  boxCommunicationChannel:any = {
    id: this.commonUtilsService.createId(),
    skinsAccepted: this.skin==='steel-blue' || this.skin==='gm-law' || this.skin==='dark-blue',
    showCommentBox: false,
    showCommentList: true,
    commentList: [],
    commentListFilter: [],
    voiceRecord: {},
    unreadAmount: 0,
    fullScreen: false,
    disabledButtons: false,
    hasVoiceRecord: false,
    pdfInfo: { typePdf: 'communication-channel' },
    configPdf: {}
  }
  constructor( private context: ContextFactory,
    private permissions: UserPermisionsFactory,
    private globalCfg: GlobalCfgFactory,
    private customLanding: CustomLandingFactory,
    private downloadService: DownloadService,
    private exportService: ExportServiceService,
    private modalService: ModalServiceService,
    private dateConverterService: DateConverterService,
    private translate: AfTranslateFactory,
    private commonUtilsService: CommonUtilsService,
    private apiService: ApiServiceService) {}

  @Input() concept : any = null;
  @Input() public : any = null;
  @Input() lockComToManager: boolean = false;

  ngOnInit(){
    if(this.concept){
      this.boxCommunicationChannel.concept = this.concept;
      this.boxCommunicationChannel.conceptObjectId = this.boxCommunicationChannel.concept.conceptObjectId;
      let enableApp: boolean = (!this.isLanding && this.userPermissions !== 'none' && this.boxCommunicationChannel.conceptObjectId)?true:false;
      let enableLanding: boolean = (this.isLanding && (this.userPermissions !== 'none' || this.boxCommunicationChannel.public))?true:false;
      this.boxCommunicationChannel.disabledActions = !(!this.boxCommunicationChannel.concept.anonymized && (enableApp || enableLanding));
      if(this.boxCommunicationChannel.conceptObjectId &&  this.boxCommunicationChannel.conceptObjectId !== 'view'){
        this.getComments();
      }
    }
  }

  getComments(){
    this.apiService.get('comments/'+this.boxCommunicationChannel.conceptObjectId+'/1')
      .then((data:any)=>{
        this.getUnread(data);
        this.boxCommunicationChannel.commentList = data.reverse();
        this.showComments();
      }, (errorData:any)=>{});
  }

  getUnread(data:any){
    data.forEach((comment:any) => {
      comment.applicantMessage = (comment.managerMessage && !this.isLanding) || (!comment.managerMessage && this.isLanding);
      if(comment.unread){
        if((this.isLanding && comment.managerMessage) || (!this.isLanding && !comment.managerMessage)){
          this.boxCommunicationChannel.unreadAmount++;
          comment.unreadForUser = true;
        }
      }
    });
    if(this.boxCommunicationChannel.unreadAmount > 0 && this.isLanding && this.skin ==='dark-blue'){
      this.modalService.warningModal({ text: this.translate.instant('box-comunication-channel.new-unread'), typeButtons: 'accept' })
    }
  }

  showComments(){
    if(this.boxCommunicationChannel.commentList.length){
      this.boxCommunicationChannel.commentListFilter = [];
      this.boxCommunicationChannel.commentList.forEach((comment:any) => {
        comment.commentTextarea = comment.commentText.split('<br>').join('\r\n');
        if(comment.hasCommentAudio){
          comment.showAudioRecord = true;
          comment.noDelete = true;
          comment.name = comment.audioFileName;
        }
      });
      this.boxCommunicationChannel.commentListFilter = this.boxCommunicationChannel.commentList;
    }else{
      this.boxCommunicationChannel.commentListFilter = [];
    }
  }

  newComment(){
    this.boxCommunicationChannel.showCommentBox = true;
    if(!this.boxCommunicationChannel.fullScreen){
      this.boxCommunicationChannel.showCommentList = false;
    }
  }

  cancelComment(comment:any){
    comment.commentTextarea = comment.commentText.split('<br>').join('\r\n');
    this.boxCommunicationChannel.commentText = '';
    comment.edit = false;
    this.boxCommunicationChannel.edit = false;
    this.boxCommunicationChannel.showCommentBox = false;
    this.boxCommunicationChannel.showCommentList = true;
  }

  createNewComment(text:any){
    this.boxCommunicationChannel.disabledButtons = true;
    if(this.boxCommunicationChannel.hasVoiceRecord && !this.boxCommunicationChannel.arrayBufferLoaded){
      this.getArrayBuffer(text)
    }else{
      let textToAdd = !text? this.boxCommunicationChannel.commentText.replace(/(?:\r\n|\r|\n)/g, '<br>'): text;
      let comment: any = {
        commenttext: textToAdd,
        communicationChannel: true,
        managerMessage: !this.isLanding,
        commentAudio: this.boxCommunicationChannel.hasVoiceRecord? this.boxCommunicationChannel.arrayBuffer : null,
        audioFileName: this.boxCommunicationChannel.hasVoiceRecord? this.boxCommunicationChannel.voiceRecord.name: null,
        audioDuration: this.boxCommunicationChannel.hasVoiceRecord? this.boxCommunicationChannel.voiceRecord.maxTime: null
      }
      this.apiService.add('comments/'+this.boxCommunicationChannel.conceptObjectId, comment)
        .then((data:any)=>{
          data.author = this.context.user.fullName;
          this.configureNewComment(data, false);
          this.boxCommunicationChannel.disabledButtons = false;
        }, (errorData: any)=>{
          this.boxCommunicationChannel.disabledButtons = false;
        });
    }
  }

  getArrayBuffer(text:string){
    let fileReader = new FileReader();
    fileReader.onload = (event:any)=>{
      this.boxCommunicationChannel.arrayBuffer = [...new Uint8Array(event.target.result)];
      this.boxCommunicationChannel.arrayBufferLoaded = true;
      this.createNewComment(text)
    };
    fileReader.readAsArrayBuffer(this.boxCommunicationChannel.voiceRecord.file);
  }

  configureNewComment(data:any, keepList:any){
    this.boxCommunicationChannel.showCommentBox = false;
    this.boxCommunicationChannel.showCommentList = true;
    this.boxCommunicationChannel.commentText = '';
    if(!keepList){
      this.boxCommunicationChannel.commentList.splice(0, 0, data);
    }
    this.showComments();
  }

  closeComment(){
    this.boxCommunicationChannel.showCommentBox = false;
    this.boxCommunicationChannel.showCommentList = true;
  }

  markAsRead(comment:any){
    this.apiService.patch('comments/', comment.commentId+'/set-unread/false').
    then((data:any)=>{
      comment.unread = false;
      comment.unreadForUser = false;
      this.boxCommunicationChannel.unreadAmount--;
    })
  }

  listenVoiceRecord(voiceRecord:any = null){
    let voiceRecorder: any = voiceRecord !== null? voiceRecord : this.boxCommunicationChannel.voiceRecord;
    this.modalService.listenRecord(voiceRecorder).subscribe((result:any)=>{
      if(result.result ==='delete'){
        this.boxCommunicationChannel.hasVoiceRecord = false;
        this.boxCommunicationChannel.voiceRecord = {};
        this.boxCommunicationChannel.commentText = '';
      }
    })
  }

  openRecordVoice(){
    this.modalService.recordAudioModal({})
    .subscribe((result:any)=>{
      if(result.result ==='ok'){
        this.boxCommunicationChannel.hasVoiceRecord = true;
        this.boxCommunicationChannel.voiceRecord = {
          player: result.player,
          text: result.text,
          maxTime: result.maxTime,
          secondsRecord: result.secondsRecord,
          name: result.name,
          recordingFile: result.recordingFile,
          file: result.file
        }
        this.boxCommunicationChannel.commentText = result.text;
      }
    })
  }

  downloadPdf(){
    let config: any = {
      conceptObjectId: this.concept.conceptObjectId,
      idPrint: 'pdf-historic-communication-channel',
      uploadFile: true,
      landscape: false,
      successCallback: (uploadResponse:any, blob:any) => {
        this.concept.documentation.documents.push(uploadResponse);
        this.concept.documentation.totalDocuments++;
        this.downloadService.triggerDownload(blob, uploadResponse.name);
        // text =  this.translate.instant(text).replace('{template}',  this.generateDocument.document.templateName
        this.modalService.successModal({ text: this.translate.instant('documentation-list.export-list-ok').replace('{0}',uploadResponse.name) });
      }
    };

    config.exportDate = this.dateConverterService.setTimezone(new Date());
    config.nameDocument = this.getNameDocument();
    this.boxCommunicationChannel.configPdf = config;
    let that = this;
    setTimeout(()=>{
      let htmlPrint = $('#pdf-historic-communication-channel').html();
      config.htmlPrint = htmlPrint;
      that.exportService.toPdf(config);
    });
  }

  getNameDocument(){
    let name : any = 'sistemademensajeria';
    let nameOrigin : any = 'sistemademensajeria';
    let nameIdx : any = 0;
    let existingReport:any;
    do {
      if (nameIdx) {
        name = nameOrigin+' (' + nameIdx + ')';
      }
      existingReport = this.concept.documentation.documents.find((item:any)=>
        item.extension.toLowerCase() === 'pdf' && (item.name.substr(0, item.name.indexOf('.pdf'))).toLowerCase() === name.toLowerCase()
      );
      nameIdx++;
    } while (existingReport);

    return name + '.pdf';
  }

  ngOnDestroy(){
    this.commonUtilsService.OnDestroy(this.subscribers);
  }
}
